var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.resource/app/list/item/admin-links/resource-list-item-dropdown-admin-links.pug");
module.exports = (req['default'] || req).apply(req, [])